module.exports = __webpack_public_path__ + "static/media/rAllen.3609e0d1.jpeg";